// extracted by mini-css-extract-plugin
export default {"SelectedComponent":"Sidebar_SelectedComponent__muC+r","Main":"Sidebar_Main__9YusY"};